/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: Der Widget startet das entsprechende
 * GUI-Element/Widget. Folgende Widgets stehen zur Verfügung:
 *
 *  'enum'         : Aufzählung
 *  'dropdown'     : Popup/Dropdown
 *  'text'         : Einzeilige Text-Eingabe
 *  'hidden'       : Versteckter Text
 *  'number'       : Numerische Eingabe
 *  'checkbox'     : Checkbox
 *  'textarea'     : Mehrzeilige Text-Eingabe
 *  'email'        : Eingabe einer E-Mail-Adresse
 *  'date'         : Eingabe eines Datums
 *  'timestamp'    : Eingabe Datum mit Uhrzeit
 *  'url'          : Eingabe einer URL
 *  'switch'       : Einfacher on/off-Schalter
 *  'color'        : Auswahl einer Farbe
 *  'singleselect' : Auswahl eines einzelnen Wertes aus einer Liste von Werten
 *  'multiselect'  : Auswahl ein- oder mehrerer Werte aus einer Liste von Werten
 *  'choice'       : Auswahl ein- oder mehrerer Werte basierend auf zwei Listen
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as appActions from "../../../store/actions/appActions";

import Text from './GUIwidgets/Text';
import Number from './GUIwidgets/Number';
import Switch from './GUIwidgets/Switch';
import Checkbox from './GUIwidgets/Checkbox';
import Textarea from './GUIwidgets/Textarea';
import Dropdown from './GUIwidgets/Dropdown';
import Select from './GUIwidgets/Select';
import Choice from './GUIwidgets/Choice';
import Reorder from './GUIwidgets/Reorder';

import MUIText from './MUIwidgets/Text';
import MUINumber from './MUIwidgets/Number';
import MarkdownEditor from './MUIwidgets/MarkdownEditor';

class FieldController extends React.Component {
	constructor(props) {
		super(props);

		this.debug = false;

		this.state = {
			validationState: this.props.validationState,
			validationMessage: this.props.validationMessage,
			value: ''
		};
	}

	/*==========================================================================
	 *
	 * ACTION - SECTION
	 *
	 *==========================================================================*/

	validateWidget(value) {
		if (this.debug) console.log('FieldController:validateWidget(' + value + ')', this.props);

		var validationMessage = null;
		var regEx = null;

		if (value.length > 0) {
			if (this.props.validation != null && this.props.validation.length > 0) {
				regEx = new RegExp(this.props.validation);
				if (regEx.test(value) === false) {
					if (this.debug) console.log('doValidation(' + value + ') regex=[' + this.props.validation + ']');
					validationMessage = (this.props.validationMessage) ? this.props.validationMessage : "Value is invalid!";
				}
			}
		}

		var validationState = (validationMessage === null) ? null : "error";

		this.setState({ validationState: validationState, validationMessage: validationMessage });

		this.props.onChange(this.props.id, this.state.value, validationState, validationMessage);

		return true;
	}

	/*==========================================================================
	 *
	 * LIFESYCLE - SECTION
	 *
	 *==========================================================================*/

	componentDidMount() {
		//console.log('Widget:componentDidMount()', this.props);

		this.setState({ value: this.props.value });
	}

	/*==========================================================================
	 *
	 * WIDGET - SECTION
	 *
	 *==========================================================================*/

	getWidget() {

		const onSelect = (value) => {
			if (this.debug) console.log('FieldController:onSelect(' + this.props.field + ') selected:', value);

			this.props.onChange(this.props.id, value, null, null);

			return false;
		}

		const onChange = (e, value) => {
			if (this.debug) console.log('FieldController:onChange(' + this.props.id + ') value:', value);

			this.setState({ value: value });
		}

		const onChangeDirect = (e, value) => {
			if (this.debug) console.log('FieldController:onChangeDirect(' + this.props.id + ') value:', value);

			this.setState({ value: value });

			this.props.onChange(this.props.id, value, null, null);
		}

		const onKeyPress = (event) => {
			if (this.debug) console.log('FieldController:onKeyPress() key:', event.key);

			if (this.props.widget === 'textarea') return;

			if (event.key === 'Enter') {
				console.log('Enter pressed');
				event.preventDefault();
				this.validateWidget(event.target.value);
			}
		}

		const onBlur = (event) => {
			if (this.debug) console.log('FieldController:onBlur()');

			this.validateWidget(event.target.value);
		}

		switch (this.props.widget) {

			case 'enum':
			case 'dropdown': return <Dropdown
				field={this.props}
				value={this.state.value}
				onChange={onChange} />;
			case 'switch': return <Switch
				field={this.props}
				value={this.state.value}
				onChange={onChange} />;
			case 'checkbox': return <Checkbox
				field={this.props}
				value={this.state.value}
				onChange={onChange} />;
			case 'number': return <Number
				field={this.props}
				value={this.state.value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'MUInumber': return <MUINumber
				field={this.props}
				value={this.state.value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'textarea': return <Textarea
				field={this.props}
				value={this.state.value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'MUIeditor': return <MarkdownEditor
				field={this.props}
				value={this.state.value}
				onChange={onChangeDirect} />;
			case 'text': return <Text
				field={this.props}
				value={this.state.value}
				type={"text"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'MUItext': return <MUIText
				field={this.props}
				value={this.state.value}
				type={"text"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'url': return <Text
				field={this.props}
				value={this.state.value}
				type={"text"}
				icon={"link"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'email': return <Text
				field={this.props}
				value={this.state.value}
				type={"text"}
				icon={"email"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'date': return <Text
				field={this.props}
				value={this.state.value}
				type={"date"}
				icon={"date"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'color': return <Text
				field={this.props}
				value={this.state.value}
				type={"color"}
				onChange={onChange}
				onBlur={onBlur} />;
			case 'timestamp': return <Text
				field={this.props}
				value={this.state.value}
				type={"text"}
				icon={"time"}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur} />;
			case 'hidden': return <Text
				field={this.props}
				value={this.state.value}
				type={"hidden"} />;
			case 'singleselect': return <Select
				field={this.props}
				value={this.props.value}
				onSelect={onSelect} />;
			case 'multiselect': return <Select
				field={this.props}
				value={this.props.value}
				onSelect={onSelect} />;
			case 'choice': return <Choice
				field={this.props}
				value={this.props.value}
				onSelect={onSelect} />;
			case 'reorder': return <Reorder
				field={this.props}
				value={this.props.value}
				onSelect={onSelect} />;
			default: return null;
		}
	}

	/*==========================================================================
	 *
	 * RENDER - SECTION
	 *
	 *==========================================================================*/

	render() {

		var align = (this.props.widget === 'textarea' || this.props.widget.indexOf('select')) ? 'items-top' : 'items-center';

		if (this.props.widget.indexOf('MUI') !== -1 || this.props.label === "" || this.props.widget === 'choice' || this.props.widget === 'reorder') {
			/**
			 * Falls kein Label angegeben wurde, wird das Widget in voller Breite dargestellt
			 * Im choice-Widget wird für die beiden Tabellen die volle Breite benötigt. Der Label
			 * wird dann über den beiden Tabellen angezeigt.
			 */
			return (
				<div className="w-full flex-col">
					{this.getWidget()}
					{this.state.validationState && <p className="text-red-500 text-sm italic">{this.state.validationMessage}</p>}
				</div>
			)
		} else {
			/**
			 * Wurde im Widget ein Label hinterlegt, dann wird dieser links neben dem Widget angezeigt
			 * die Aufteilung ist 1/3 der Breite für den Label,  2/3 der Breite für das Widget
			 */
			return (
				<div className="w-full flex-col">
					<div className={"w-full flex " + align}>
						<div className="w-1/3 text-right text-black px-2 py-4">
							{this.props.label}
						</div>
						<div className="w-2/3 text-left px-2 ">
							<div className="w-full flex flex-col">
								{this.getWidget()}
								{this.state.validationState && <p className="text-red-500 text-sm italic">{this.state.validationMessage}</p>}
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		app: state.app,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldController);